import { AITextGenerationLocalContextType } from '../../../AITextGeneration'
import {
  EMAIL_CREATION_FORM_TEMPLATE_FOLDER_REQUEST,
  EmailCreationPopUp,
  isDirtyEmailCreationForm,
} from '../../../Email'
import { MINIMIZED_MODAL_SCOPE } from '../../../Modal'
import { useRequestProfileContext } from '../../RequestProfile.hooks'

import { RequestProfileTabEmailsCreateEmailModeField } from './RequestProfileTabEmailsCreateEmailModeField'
import {
  CREATE_EMAIL_POPUP_MODE_FIELD_NAME,
  CREATE_EMAIL_POPUP_MODE_STANDARD,
} from './RequestProfileTabEmailsCreateEmailPopUp.constants'
import { useRequestProfileTabEmailsCreateEmailForm } from './RequestProfileTabEmailsCreateEmailPopUp.hooks'
import {
  getRequestEmailAttachProps,
  getRequestPreviewDependencyValues,
  getRequestTemplateEntityApiParams,
  getRequestTemplateListApiParams,
} from './RequestProfileTabEmailsCreateEmailPopUp.utils'

function RequestProfileTabEmailsCreateEmailPopUp({
  audience,
  initialValues,
  isLeaveGuardEnabled,
  minimizedModalScope = MINIMIZED_MODAL_SCOPE.REQUEST_PROFILE,
  requestData,
  requestId,
  onClose,
  onSendSuccess,
}) {
  const { relatedRequestsCount } = useRequestProfileContext()

  const {
    fieldsProps,
    handleSubmit,
    handleSuccess,
    isAttachedRequestsMode,
    modeFieldProps,
  } = useRequestProfileTabEmailsCreateEmailForm({
    audience,
    initialValues,
    requestData,
    onClose,
    onSendSuccess,
  })

  const popupInitialValues = {
    ...initialValues,
    [CREATE_EMAIL_POPUP_MODE_FIELD_NAME]:
      initialValues?.[CREATE_EMAIL_POPUP_MODE_FIELD_NAME] ??
      CREATE_EMAIL_POPUP_MODE_STANDARD,
  }

  const modeField =
    relatedRequestsCount > 0 ? (
      <RequestProfileTabEmailsCreateEmailModeField {...modeFieldProps} />
    ) : null

  const attachProps = getRequestEmailAttachProps({ requestData, requestId })

  const templateListApiParams = getRequestTemplateListApiParams({
    buildingId: requestData?.building?.id,
    isAttachedRequestsMode,
  })

  const templateEntityApiParams = getRequestTemplateEntityApiParams({
    flatId: requestData?.flat?.id,
    isAttachedRequestsMode,
    requestId,
  })

  function getPreviewDependencies(recipient) {
    return getRequestPreviewDependencyValues({
      isAttachedRequestsMode,
      recipient,
      requestId,
    })
  }

  return (
    <EmailCreationPopUp
      aiLocalContext={{
        object_id: String(requestId),
        type: AITextGenerationLocalContextType.ServiceRequestEmail,
      }}
      fieldsProps={fieldsProps}
      formFieldsProps={{
        PriorityFieldComponent: null,
        attachProps,
        beforeContent: modeField,
        disableDuplicateRecipientsValidation: isAttachedRequestsMode,
        getPreviewDependencies,
        hideCcBcc: isAttachedRequestsMode,
        templateListApiParams,
      }}
      getIsDirty={isDirtyEmailCreationForm}
      initialValues={popupInitialValues}
      isLeaveGuardEnabled={isLeaveGuardEnabled}
      minimizedModalScope={minimizedModalScope}
      singleTemplateFolder={EMAIL_CREATION_FORM_TEMPLATE_FOLDER_REQUEST}
      templateEntityApiParams={templateEntityApiParams}
      onClose={onClose}
      onSubmit={handleSubmit}
      onSuccess={handleSuccess}
    />
  )
}

export default RequestProfileTabEmailsCreateEmailPopUp
